import { Component, OnInit, TemplateRef, ViewChild, OnDestroy, Renderer2, AfterViewInit, ElementRef, DOCUMENT, inject } from '@angular/core';
import { registerLocaleData, Location, NgStyle } from '@angular/common';
import localeEn from '@angular/common/locales/en';
import localeIt from '@angular/common/locales/it';
import localeDe from '@angular/common/locales/de';
import localeEl from '@angular/common/locales/el';
import localeEs from '@angular/common/locales/es';
import localeFr from '@angular/common/locales/fr';
import localePt from '@angular/common/locales/pt';
import localeRo from '@angular/common/locales/ro';
import localeRu from '@angular/common/locales/ru';
import localeSq from '@angular/common/locales/sq';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Router, NavigationEnd, ActivationEnd, NavigationStart } from '@angular/router';
import { GlobalHandlerService } from '@core/services/global-handler.service';
import { SharedService } from '@core/services/shared.service';
import { Subscription } from 'rxjs';
import { KeycloakService, KeycloakEvent } from 'keycloak-angular';
import {  Meta, Title } from '@angular/platform-browser';
import { isDefined } from '@shared/heplers/helpers';
import { ITALIA_INITIALS, languages } from '@shared/heplers/const-data';
import { environment } from 'src/environments/environment';
import { loadCachedScript } from './utils/load-script';
import { GtmService } from '@shared/services/gtm.service';
import { customEcommerce } from 'src/assets/custom-ecommerce/custom';
import { CNotificationComponent } from './shared/features/c-notification/c-notification/c-notification.component';
import { NotifierModule } from 'angular-notifier';
import { FuseMainComponent } from './main/main.component';
import { CookiePreferenceService } from '@core/services/cookie.service';
import { CookieService } from 'ngx-cookie-service';
import { CustomPageService } from '@shared/services/custom-pages.service';
declare var $: any;

declare global {
  interface Window {
    onIubendaPreferenceExpressed: (param: any) => void;
  }
}
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [FuseMainComponent, NotifierModule, CNotificationComponent, NgStyle, TranslateModule]
})
export class AppComponent implements OnInit,OnDestroy,AfterViewInit {
  translate = inject(TranslateService);
  private router = inject(Router);
  private shareService = inject(SharedService);
  private globalHandlerService = inject(GlobalHandlerService);
  private keycloakService = inject(KeycloakService);
  private cookiePreferenceService = inject(CookiePreferenceService);
  private cookieService = inject(CookieService);
  private titleService = inject(Title);
  private metaService = inject(Meta);
  private gtmServiceAddScript = inject(GtmService);
  private customPageService = inject(CustomPageService);
  private location = inject(Location);
  private renderer = inject(Renderer2);
  private elementRef = inject(ElementRef);
  private document = inject<Document>(DOCUMENT);

  public url: any;
  @ViewChild("customNotification", { static: true })
  customNotificationTmpl: TemplateRef<any>;
  keycloakEventsListener: Subscription
  isUserPr : boolean
  subscription: Subscription;
  areInPrRoutes : boolean
  showPopup:boolean = true
  isAppInstalled = false;
  toTopBtnColor : any
  marketingCookie : boolean
  redirecting = false;
  hasProductRparam : boolean
  setR : boolean
  rValue : string

  desc:string
  constructor() {
    const translate = this.translate;

    this.dynamicFavIcon();
    // this.gtmService.pushTag({
    //   event: 'gtm.js'
    // });

    translate.addLangs(languages);
     if(this.hasLangParam()){
      translate.setDefaultLang(this.hasLangParam());
      translate.use(this.hasLangParam());
     }else{
      const defaultLang = localStorage.getItem('language') || this.getDeviceLanguage();
      translate.setDefaultLang(defaultLang);
      translate.use(defaultLang);
     }
    this.router.events.subscribe((event) => {
      

      if (event instanceof NavigationStart) {
       if (this.redirecting) {
          this.redirecting = false;
          return;
        }
        const url = new URL(event.url, window.location.origin);

        if((url.searchParams.has('r') || url.searchParams.has('clickref'))){
          if(url.searchParams.has('r')){
            this.setR = true
          }
          this.rValue = url.searchParams.get('r') || url.searchParams.get('clickref');
          this.hasProductRparam = true 

        }
        if(this.hasProductRparam){
           url.searchParams.set(this.setR ? 'r' : 'clickref', this.rValue );
          const newUrl = `${url.pathname}?${url.searchParams.toString()}`;
          this.redirecting = true;

          this.router.navigateByUrl(newUrl, { replaceUrl: false });
        }
      
      
    }
      if (event instanceof ActivationEnd && event.snapshot.children.length === 0) {
        let application_title_lang = "seo_information.application_title";
        let page_title_lang 
        let page_desc_lang = ''
        if(event.snapshot.data.title === 'register'){
          page_title_lang  = `seo_information.${event.snapshot.data.title}.title`;
          page_desc_lang = `seo_information.${event.snapshot.data.title}.description`;
        }else(
          page_title_lang  = `seo_information.${event.snapshot.data.title}`
          )

        this.translate.get([application_title_lang, page_title_lang, page_desc_lang ]).subscribe(
          (response) => {
            this.desc=response[page_desc_lang]
             let application_title = response[application_title_lang],
            route_title = response[page_title_lang],
            page_title = isDefined(event.snapshot.data.title) && isDefined(route_title)?
              `${application_title} - ${route_title}` : application_title;

              if(this.shareService.checkRoute()){
                const subdomain = this.shareService.getCustomDomain();
                this.titleService.setTitle(customEcommerce[subdomain].customPageTitle);
              }else{
              this.titleService.setTitle(page_title);
              }

            if(page_title_lang === 'seo_information.register.title'){
              this.metaService.updateTag({ name: 'description', content:this.desc ,});
            }else{
              this.metaService.updateTag({ name: 'description', content: "Ciaotickets Ecommerce",});
            }
        });
      }
    });
  }

  ngOnInit() {
    window.onIubendaPreferenceExpressed = (preference: any) => {
     this.manageConsent(preference)
    };
    if(this.shareService.checkRoute()){
      this.toTopBtnColor = customEcommerce[this.shareService.getCustomDomain()].stepBackgropund
    }else{
      this.addMetaTags();
    }
    this.gtmServiceAddScript.initializeGtm();
    let popupState = window.localStorage.getItem("popup");
    let appInstalled = window.localStorage.getItem("appInstalled");
    if(appInstalled){
      this.isAppInstalled = appInstalled.toLowerCase() === 'true';
    }
    if(popupState){
      this.showPopup = popupState.toLowerCase() === 'true';
    }
    this.subscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.url = event.url;
       this.areInPrRoutes = this.shareService.checkCurrentRoute(event.url) && window.innerWidth < 576;
      }
    });
    this.addExternalResources();
    this.getRoles();
    this.addManifestLink();
    this.addListenerViewer();
    this.listenerKeycloakEvents();
    loadCachedScript(`assets/js/script.js?cb=${environment.cb}`);
    this.globalHandlerService.setTemplateNotifier(this.customNotificationTmpl);
    this.registerAllLocales();
    const hostname = window.location.hostname;
    const subdomain = this.shareService.getCustomDomain();
    this.customPageService.setCustomStyles(hostname,subdomain,customEcommerce,environment)
  }

  ngOnDestroy() {
    this.keycloakEventsListener.unsubscribe();
  }

  dynamicFavIcon(){
    loadCachedScript(`assets/custom-ecommerce/custom-favicon-loader.js?cb=${environment.cb}`);
    const favicon = this.renderer.createElement('script');
    this.renderer.setAttribute(favicon, 'src', `assets/js/fav-icon.js?cb=${environment.cb}`);
    this.renderer.appendChild(document.body, favicon);
  }

  getDeviceLanguage(): string {
   const language = navigator.language.split('-')[0];
   return this.shareService.languages.includes(language) ? language : 'en';
  }

 manageConsent(preference){
   if(!preference.purposes['5']){
          this.marketingCookie = false
          this.deleteAllRCookies()
        }else{
          this.marketingCookie = true
        }
      this.cookiePreferenceService.setPreference(preference);
 }

 deleteAllRCookies() {
   const allCookies = this.cookiePreferenceService.getAllRPatternCookies(); 
   const hostname = window.location.hostname;
   this.cookieService.delete('rhome', '/',hostname);
    Object.keys(allCookies).forEach(cookieName => {
    if (/-r-/.test(cookieName)) {
      this.cookieService.delete(cookieName, '/',hostname);
    }
   });
  }

  hasLangParam() {
    const currentUrl = this.location.path();
    const urlObj = new URL(currentUrl, environment.host);
    const lang = urlObj.searchParams.get('lang');
    
    if (lang && this.shareService.languages.includes(lang)) {
      localStorage.setItem('language', lang);
      return lang;
    }
    return;
  }
  

  registerAllLocales() {
    registerLocaleData(localeEn, 'en');
    registerLocaleData(localeIt, 'it');
    registerLocaleData(localeDe, 'de');
    registerLocaleData(localeEl, 'el');
    registerLocaleData(localeEs, 'es');
    registerLocaleData(localeFr, 'fr');
    registerLocaleData(localePt, 'pt');
    registerLocaleData(localeRo, 'ro');
    registerLocaleData(localeRu, 'ru');
    registerLocaleData(localeSq, 'sq');
  }


  listenerKeycloakEvents() {
    this.keycloakEventsListener = this.keycloakService.keycloakEvents$.subscribe((event: KeycloakEvent) => {
      if (event.type == 3) {
        this.keycloakService.getToken().then((token) => {
          localStorage.setItem("authToken", token);
        })
      }
    })
  }

  

  onClosePopUp(){
    window.localStorage.setItem("popup", 'false');
    this.showPopup = false;
  }

  getRoles(){
    let data=this.keycloakService.getUserRoles()
    
    let roleFound = false;
    let prFound = false; 
    
    for (let [key, value] of Object.entries(data)) {
        if (value === 'ROLE_PR_ADMIN' && !roleFound) {
          this.isUserPr = true;
          roleFound = true;
        } else if (value === 'ROLE_PR') {
          this.isUserPr = true;
            prFound = true;
        }
    }

    if (roleFound && prFound) {
        this.isUserPr = true;

      } else if (!roleFound && !prFound) {
        this.isUserPr = false;
    }
  } 

  addManifestLink() {
    this.keycloakService.isLoggedIn().then((isLoggedIn)=>{
      const customDomain = this.shareService.getCustomDomain();
      const isPwaActivated =  customEcommerce[customDomain] ? customEcommerce[customDomain].pwaActivated : true ;
      if(isLoggedIn && this.isUserPr && isPwaActivated ) {
        if (!document.querySelector('link[rel="manifest"]')) {
          const link = this.renderer.createElement('link');
          this.renderer.setAttribute(link, 'rel', 'manifest');
          this.renderer.setAttribute(link, 'href', 'manifest.webmanifest');
          this.renderer.appendChild(document.head, link);
        }
      }
    });
  }

  addMetaTags(): void {
    const appleMetaTag = this.renderer.createElement('meta');
    this.renderer.setAttribute(appleMetaTag, 'name', 'apple-mobile-web-app-status-bar');
    this.renderer.setAttribute(appleMetaTag, 'content', '#f0f3f7');
    this.renderer.appendChild(this.document.head, appleMetaTag);

    const themeMetaTag = this.renderer.createElement('meta');
    this.renderer.setAttribute(themeMetaTag, 'name', 'theme-color');
    this.renderer.setAttribute(themeMetaTag, 'content', '#f0f3f7');
    this.renderer.appendChild(this.document.head, themeMetaTag);
  }

  addListenerViewer() {
    if (window.addEventListener) {
      window.addEventListener("message", this._listenerToPurchaseViewer, false);
      this.keycloakService.isLoggedIn().then((isLoggedIn)=>{
        if(isLoggedIn) {
          window.addEventListener("storage", this._checkAuthToken, false);
        }
      });
    }
  }

  ngAfterViewInit() {

    const script = this.renderer.createElement('script');
    this.renderer.setAttribute(script, 'src', 'https://cdn.jsdelivr.net/gh/philfung/add-to-homescreen@2.2/dist/add-to-homescreen.min.js');
    this.renderer.appendChild(document.body, script);
    
    script.onload = () => {
      this.isScriptLoaded = true;
    };

  }

  isScriptLoaded = false;

  addExternalResources() {
    const link = this.renderer.createElement('link');
    this.renderer.setAttribute(link, 'rel', 'stylesheet');
    this.renderer.setAttribute(link, 'href', 'https://cdn.jsdelivr.net/gh/philfung/add-to-homescreen@2.2/dist/add-to-homescreen.min.css');
    this.renderer.appendChild(document.head, link);
  }

  onAddToHomeScreenClick() {
    if (!this.isScriptLoaded) {
      console.error('Add to Home Screen script is not loaded yet.');
      return;
    }

    const addToHomeScreen = new (window as any).AddToHomeScreen({
      appName: 'Ciaotickets PR',
      appIconUrl: 'assets/icons/ctPR.png',
      assetUrl: 'https://cdn.jsdelivr.net/gh/philfung/add-to-homescreen@2.2/dist/assets/img/',
      maxModalDisplayCount: -1
    });

    (window as any).AddToHomeScreenInstance = addToHomeScreen;
    addToHomeScreen.show('en');
    
    let lang = localStorage.getItem('language');
  
    
    if(lang === 'it' || localStorage.getItem('language') === null ){
     if(/android/i.test(navigator.userAgent)){
      const divElement = document.getElementsByClassName('adhs-instruction');
      const divElementMEssage = document.getElementsByClassName('adhs-blurb');
      const divElementTitle = document.getElementsByClassName('adhs-install-app');

      
      if (divElementTitle[0]) {
        this.renderer.setProperty(divElementTitle[0], 'innerHTML', `Installa`);
      }
      if (divElement[0]) {
        const imgHTML = '<img src="./assets/icons/android-chrome-more-button.svg" alt="Image description" style="vertical-align: middle; height: 37px; background: white; border-radius: 10px;">';
        this.renderer.setProperty(divElement[0], 'innerHTML', `Premi il punsante ${imgHTML} nella barra del browser`);
      }

      if (divElement[1]) {

        const imgHTML = '<img src="./assets/icons/android-chrome-add-to-home-screen-button_it_2.svg" alt="Image description" style="vertical-align: middle; background: white; border-radius: 10px;margin-bottom: 5px;width: 233px">';
        const imgHTML2 = '<img src="./assets/icons/android-chrome-install-app_it_2.svg" alt="Image description" style="vertical-align: middle; background: white; border-radius: 10px;width: 150px">';
        this.renderer.setProperty(divElement[1], 'innerHTML', `Premi su ${imgHTML} oppure ${imgHTML2}`);
      }

      if (divElementMEssage[0]) {
        this.renderer.setProperty(divElementMEssage[0], 'innerHTML', `Un'icona verrà aggiunta alla schermata iniziale per consentirti di accedere rapidamente a questo sito web.`);
      }

    }else{
      const divElement = document.getElementsByClassName('adhs-instruction');
      const divElementMEssage = document.getElementsByClassName('adhs-blurb');
      const divElementTitle = document.getElementsByClassName('adhs-install-app');
      
      if (divElementTitle[0]) {
        this.renderer.setProperty(divElementTitle[0], 'innerHTML', `Installa`);
      }

      if (divElement[0]) {

        const imgHTML = '<img src="./assets/icons/ios-chrome-more-button.svg" alt="Image description" style="vertical-align: middle; height: 35px; background: white; border-radius: 10px;">';
        this.renderer.setProperty(divElement[0], 'innerHTML', `Premi il punsante  ${imgHTML} nella barra del browser`);
      }

      if (divElement[1]) {

        const imgHTML = '<img src="./assets/icons/ios-chrome-add-to-home-screen-button_it_2.svg" alt="Image description" style="vertical-align: middle; background: white; border-radius: 10px;margin-bottom: 5px">';
        this.renderer.setProperty(divElement[1], 'innerHTML', `Selezionare ${imgHTML}  dal menu che si apre. <strong>Potrebbe essere necessario scorrere verso il basso per trovare questa voce di menu</strong>`);
      }

      if (divElementMEssage[0]) {
        this.renderer.setProperty(divElementMEssage[0], 'innerHTML', `Un'icona verrà aggiunta alla schermata iniziale per consentirti di accedere rapidamente a questo sito web.`);
      }

    }
    }

    window.addEventListener('appinstalled', () => {
      console.log('PWA was installed');
      window.localStorage.setItem("appInstalled", 'true');
      this.isAppInstalled = true
    });
  }

  private _listenerToPurchaseViewer = (event) => {
    // console.log(event);
    if (event.data) {
      this.shareService.purchaseViewerObserver.emit(event.data);
    }
  }

  private _checkAuthToken = () => {
    const token = localStorage.getItem("authToken");
    if (!token) {
      this.keycloakService.updateToken().then((updated) => {
        console.log('updated', updated)
        this.keycloakService.getToken().then((token) => {
          localStorage.setItem("authToken", token);
        })
      })
    }
  }
}
